import React from 'react';
import PropTypes from "prop-types";

const NewsletterForm = ({emailValue, handleEmailChange, onSubmit, errors}) => (
    <form>
        <div className="form-group">
            <input
                className="form-control"
                id="newsletter-email"
                type="email"
                placeholder="Email"
                value={emailValue}
                onChange={handleEmailChange}
            />
        </div>
        <div className="form-group">
            <button
                className="btn btn-secondary"
                onClick={onSubmit}
            >
                Sign me up!
            </button>
        </div>
        {errors.length > 0 &&
        errors.map(error => (
            <div className="alert alert-danger" key={error}>
                {error}
            </div>
        ))
        }
    </form>
);

NewsletterForm.propTypes = {
    emailValue: PropTypes.string.isRequired,
    handleEmailChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default NewsletterForm;



// WEBPACK FOOTER //
// ./src/components/NewsletterForm.js